import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "tooltip-container" }
const _hoisted_2 = { class: "tooltip-container" }
const _hoisted_3 = { class: "tooltip-container" }
const _hoisted_4 = { class: "tooltip-container" }
const _hoisted_5 = { class: "tooltip-container" }
const _hoisted_6 = { class: "tooltip-container" }
const _hoisted_7 = { class: "tooltip-container" }
const _hoisted_8 = { class: "tooltip-container" }
const _hoisted_9 = { class: "tooltip-container" }
const _hoisted_10 = { class: "tooltip-container" }
const _hoisted_11 = { class: "tooltip-container" }
const _hoisted_12 = { class: "tooltip-container" }
const _hoisted_13 = { class: "tooltip-container" }
const _hoisted_14 = {
  key: 1,
  class: "text-grey text-caption align-self-center"
}
const _hoisted_15 = {
  key: 1,
  class: "text-grey text-caption align-self-center"
}
const _hoisted_16 = { class: "tooltip-container" }
const _hoisted_17 = { class: "tooltip-container" }
const _hoisted_18 = { class: "tooltip-container" }
const _hoisted_19 = { class: "tooltip-container" }
const _hoisted_20 = { class: "tooltip-container" }
const _hoisted_21 = { class: "tooltip-container" }
const _hoisted_22 = { class: "tooltip-container" }
const _hoisted_23 = { style: {"overflow":"hidden"} }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { style: {"overflow":"hidden"} }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "tooltip-container" }
const _hoisted_28 = { class: "tooltip-container" }
const _hoisted_29 = { class: "tooltip-container" }
const _hoisted_30 = { class: "tooltip-container" }
const _hoisted_31 = { class: "tooltip-container" }
const _hoisted_32 = { class: "tooltip-container" }
const _hoisted_33 = { class: "tooltip-container" }
const _hoisted_34 = { class: "tooltip-container" }
const _hoisted_35 = { class: "tooltip-container" }
const _hoisted_36 = { class: "tooltip-container" }
const _hoisted_37 = { class: "tooltip-container" }
const _hoisted_38 = { class: "tooltip-container" }
const _hoisted_39 = { style: {"overflow":"hidden"} }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { style: {"overflow":"hidden"} }
const _hoisted_42 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_autocomplete_filled = _resolveComponent("v-autocomplete-filled")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_SirenCompanyDialog = _resolveComponent("SirenCompanyDialog")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_AccountingOffer = _resolveComponent("AccountingOffer")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_BusinessOffer = _resolveComponent("BusinessOffer")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_ResourceAllocationEdition = _resolveComponent("ResourceAllocationEdition")!
  const _component_AccountingFirmClientEdition = _resolveComponent("AccountingFirmClientEdition")!
  const _directive_tool_tip = _resolveDirective("tool-tip")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_v_row, { "no-gutters": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-end"
      }, {
        default: _withCtx(() => [
          (!_ctx.actions && !_ctx.auditReportMode)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "2"
              }, {
                default: _withCtx(() => [
                  (!_ctx.clientInvoiceMode && !_ctx.hideUpsertBtn)
                    ? (_openBlock(), _createBlock(_component_v_btn_primary, {
                        key: 0,
                        block: "",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.upsertCompany())),
                        disabled: _ctx.disabledModification,
                        "data-cy": "EditCompany-valid",
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.company.id ? "Modifier" : "Créer"), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-end",
        style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "default_card large mx-0 my-2 pa-2",
                elevation: "0",
                id: "MainInformationEditCompany"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "d-flex justify-start align-center pb-2"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.clientInvoiceMode
                                        ? "Information sur votre client"
                                        : "Informations sur votre entreprise"), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_form, {
                    modelValue: _ctx.isCompanyDetailsFormValid,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isCompanyDetailsFormValid) = $event)),
                    disabled: _ctx.auditReportMode
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            class: "d-flex pb-2 pr-2",
                            cols: "4"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, [
                                _createVNode(_component_v_text_field_filled, {
                                  ref: "companyNameElement",
                                  modelValue: _ctx.company.name,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.company.name) = $event)),
                                  label: _ctx.$t('user.companyName'),
                                  rules: _ctx.requiredRule,
                                  required: "",
                                  disabled: _ctx.getDisabled(!_ctx.adminMode && !_ctx.clientInvoiceMode),
                                  "data-cy": "EditCompany-name"
                                }, null, 8, ["modelValue", "label", "rules", "disabled"]),
                                (_ctx.$refs.companyNameElement)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      activator: "parent"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString((_ctx.$refs.companyNameElement as VTextField)?.label), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }),
                          (_ctx.clientInvoiceMode)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                class: "d-flex pb-2 pr-2",
                                cols: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_v_text_field_filled, {
                                      ref: "siretElement",
                                      modelValue: _ctx.siret,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.siret) = $event)),
                                      onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onInputSetTruncatedSiret(_ctx.siret))),
                                      label: "SIRET"
                                    }, null, 8, ["modelValue"]),
                                    (_ctx.$refs.siretElement)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          activator: "parent"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((_ctx.$refs.siretElement as VTextField)?.label), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.clientInvoiceMode)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                class: "d-flex pb-2 pr-2",
                                cols: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_3, [
                                    _createVNode(_component_v_text_field_filled, {
                                      ref: "vatNumberElement",
                                      modelValue: _ctx.company.vatNumber,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.company.vatNumber) = $event)),
                                      label: _ctx.$t('settings.vatNumber'),
                                      "data-cy": "EditCompany-vatNumber"
                                    }, null, 8, ["modelValue", "label"]),
                                    (_ctx.$refs.vatNumberElement)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          activator: "parent"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((_ctx.$refs.vatNumberElement as VTextField)?.label), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.settingsMode || !_ctx.clientInvoiceMode)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 2,
                                class: "d-flex pb-2 pr-2",
                                cols: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_component_v_text_field_filled, {
                                      ref: "companyShortNameElement",
                                      modelValue: _ctx.company.shortName,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.company.shortName) = $event)),
                                      label: _ctx.$t('settings.commercialName')
                                    }, null, 8, ["modelValue", "label"]),
                                    (_ctx.$refs.companyShortNameElement)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          activator: "parent"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((_ctx.$refs.companyShortNameElement as VTextField)?.label), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (!_ctx.clientInvoiceMode)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 3,
                                class: "d-flex pb-2 pr-1",
                                cols: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_component_v_autocomplete_filled, {
                                      ref: "legalFormElement",
                                      modelValue: _ctx.company.legalForm,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.company.legalForm) = $event)),
                                      items: _ctx.legalForms,
                                      "item-title": _ctx.formatTitle,
                                      "item-value": "id",
                                      rules: _ctx.requiredRule,
                                      required: "",
                                      disabled: _ctx.getDisabled(!_ctx.adminMode && !!_ctx.company.legalForm),
                                      label: _ctx.$t('settings.legalForm') + ' *',
                                      "data-cy": "EditCompany-legalForm"
                                    }, null, 8, ["modelValue", "items", "item-title", "rules", "disabled", "label"]),
                                    (_ctx.$refs.legalFormElement)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          activator: "parent"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((_ctx.$refs.legalFormElement as VSelect)?.label), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (!_ctx.clientInvoiceMode)
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 0,
                            "no-gutters": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "3",
                                class: "d-flex pb-2 pr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_component_v_text_field_filled, {
                                      ref: "siretElement",
                                      modelValue: _ctx.siret,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.siret) = $event)),
                                      label: "SIRET *",
                                      onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onInputSetTruncatedSiret(_ctx.siret))),
                                      required: "",
                                      disabled: _ctx.getDisabled(_ctx.disabledSiret || _ctx.auditReportMode),
                                      rules: _ctx.rulesSiret,
                                      "error-messages": _ctx.siretErrors,
                                      "data-cy": "EditCompany-siret",
                                      "onUpdate:focused": _ctx.siretToSiren
                                    }, null, 8, ["modelValue", "disabled", "rules", "error-messages", "onUpdate:focused"]),
                                    (_ctx.$refs.siretElement)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          activator: "parent"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((_ctx.$refs.siretElement as VTextField)?.label), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "3",
                                class: "d-flex pb-2 pr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_v_text_field_filled, {
                                      ref: "sirenElement",
                                      label: "SIREN",
                                      readonly: "",
                                      disabled: !_ctx.adminMode,
                                      rules: _ctx.sirenRules,
                                      "model-value": _ctx.company.siren
                                    }, null, 8, ["disabled", "rules", "model-value"]),
                                    (_ctx.$refs.sirenElement)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          activator: "parent"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((_ctx.$refs.sirenElement as VTextField)?.label), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "3",
                                class: "d-flex pb-2 pr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_v_text_field_filled, {
                                      ref: "vatNumberElement",
                                      readonly: "",
                                      label: _ctx.$t('settings.vatNumber'),
                                      disabled: !_ctx.adminMode,
                                      "model-value": _ctx.company.vatNumber
                                    }, null, 8, ["label", "disabled", "model-value"]),
                                    (_ctx.$refs.vatNumberElement)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          activator: "parent"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((_ctx.$refs.vatNumberElement as VTextField)?.label), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }),
                              (!_ctx.hideRegistrationTown)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "3",
                                    class: "d-flex pb-2 pr-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_9, [
                                        _createVNode(_component_v_combobox_filled, {
                                          ref: "registrationTownElement",
                                          modelValue: _ctx.company.registrationTown,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.company.registrationTown) = $event)),
                                          items: _ctx.registrationTowns,
                                          label: _ctx.$t('settings.registrationTown') + ' *',
                                          rules: _ctx.registrationTownRules,
                                          required: "",
                                          dense: ""
                                        }, null, 8, ["modelValue", "items", "label", "rules"]),
                                        (_ctx.$refs.registrationTownElement)
                                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                              key: 0,
                                              activator: "parent"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString((_ctx.$refs.registrationTownElement as VCombobox)?.label), 1)
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "4",
                            class: "d-flex pr-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_10, [
                                _withDirectives(_createVNode(_component_v_text_field_filled, {
                                  ref: "addressElement",
                                  modelValue: _ctx.company.address,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.company.address) = $event)),
                                  label: _ctx.$t('settings.address') + ' *',
                                  rules: _ctx.requiredRule,
                                  required: "",
                                  "data-cy": "editCompany-adress"
                                }, null, 8, ["modelValue", "label", "rules"]), [
                                  [_directive_tool_tip, _ctx.$t('settings.address') + ' *']
                                ]),
                                (_ctx.$refs.addressElement)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      activator: "parent"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString((_ctx.$refs.addressElement as VTextField)?.label), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "2",
                            class: "d-flex pr-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_v_text_field_filled, {
                                  ref: "postalCodeElement",
                                  modelValue: _ctx.company.postalCode,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.company.postalCode) = $event)),
                                  label: _ctx.$t('settings.postalCode') + ' *',
                                  rules: [
                                            ..._ctx.requiredRule,
                                            (v) => v.length === 5 || '5 Caractères',
                                        ],
                                  required: "",
                                  "data-cy": "editCompany-postalCode"
                                }, null, 8, ["modelValue", "label", "rules"]),
                                (_ctx.$refs.postalCodeElement)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      activator: "parent"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString((_ctx.$refs.postalCodeElement as VTextField)?.label), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "d-flex pr-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_v_text_field_filled, {
                                  ref: "cityElement",
                                  modelValue: _ctx.company.city,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.company.city) = $event)),
                                  label: _ctx.$t('settings.city') + ' *',
                                  rules: _ctx.requiredRule,
                                  required: "",
                                  "data-cy": "editCompany-city"
                                }, null, 8, ["modelValue", "label", "rules"]),
                                (_ctx.$refs.cityElement)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      activator: "parent"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString((_ctx.$refs.cityElement as VTextField)?.label), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "d-flex pr-1"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_v_text_field_filled, {
                                  ref: "countryElement",
                                  modelValue: _ctx.company.country,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.company.country) = $event)),
                                  label: _ctx.$t('settings.country') + ' *',
                                  rules: _ctx.requiredRule,
                                  required: "",
                                  "data-cy": "editCompany-country"
                                }, null, 8, ["modelValue", "label", "rules"]),
                                (_ctx.$refs.countryElement)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      activator: "parent"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString((_ctx.$refs.countryElement as VTextField)?.label), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"]),
                  (_ctx.researchDialog)
                    ? (_openBlock(), _createBlock(_component_SirenCompanyDialog, {
                        key: 0,
                        modelValue: _ctx.researchDialog,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.researchDialog) = $event)),
                        onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.getCompany($event)))
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              (!_ctx.clientInvoiceMode)
                ? (_openBlock(), _createBlock(_component_v_card, {
                    key: 0,
                    class: "default_card large mx-0 my-2 pa-2",
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "d-flex justify-start align-center pb-2"
                          }, {
                            default: _withCtx(() => _cache[54] || (_cache[54] = [
                              _createElementVNode("h2", null, "Détails de votre entreprise", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_form, {
                        modelValue: _ctx.isMainFormValid,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.isMainFormValid) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }),
                          (
                                (!_ctx.getDisabled(!_ctx.clientInvoiceMode && _ctx.adminMode) &&
                                    !_ctx.clientInvoiceMode) ||
                                _ctx.adminMode
                            )
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 0,
                                "no-gutters": "",
                                class: "pb-2"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.settingsMode)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        class: "d-flex pb-2 pr-2 justify-start",
                                        cols: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives((_openBlock(), _createBlock(_component_v_combobox_filled, {
                                            modelValue: _ctx.activities,
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.activities) = $event)),
                                            items: _ctx.allActivities,
                                            "item-value": "name",
                                            "item-title": _ctx.getActivityText,
                                            label: "Code NAF",
                                            chips: "",
                                            disabled: _ctx.getDisabled(!_ctx.adminMode || _ctx.auditReportMode),
                                            multiple: "",
                                            required: "",
                                            "hide-details": "auto",
                                            "data-cy": "EditCompany-activities",
                                            style: {"height":"fit-content"}
                                          }, {
                                            chip: _withCtx(({ item, index }) => [
                                              (index < 8)
                                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                                    key: 0,
                                                    class: "my-1"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("span", null, _toDisplayString(item.title), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                : (index === 8)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, " +" + _toDisplayString(_ctx.activities.length - 8) + " autre(s) ", 1))
                                                  : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue", "items", "item-title", "disabled"])), [
                                            [_directive_tooltip, 'Code NAF']
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_col, {
                                    class: "d-flex pb-2 pr-2",
                                    cols: "3"
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives((_openBlock(), _createBlock(_component_v_select_filled, {
                                        modelValue: _ctx.company.salesAccounts,
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.company.salesAccounts) = $event)),
                                        items: _ctx.availableSalesAccounts,
                                        "item-value": "name",
                                        label: 
                                        _ctx.company.solution === 'MANAGEMENT'
                                            ? _ctx.$t('settings.salesAccountingAccountManagement')
                                            : _ctx.$t('settings.salesAccountingAccount')
                                    ,
                                        multiple: "",
                                        chips: "",
                                        "return-object": "",
                                        rules: [
                                        (v) =>
                                            v.length > 0 || _ctx.$t('settings.atLeastOneItemRequired'),
                                    ],
                                        disabled: _ctx.disabledActivityModification || _ctx.auditReportMode,
                                        "data-cy": "EditCompany-vente",
                                        "item-title": (item) => item.description,
                                        style: {"height":"fit-content"}
                                      }, {
                                        chip: _withCtx(({ item, index }) => [
                                          (index < 6)
                                            ? (_openBlock(), _createBlock(_component_v_chip, { key: 0 }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", null, _toDisplayString(item.title), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : (index === 6)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, " +" + _toDisplayString(_ctx.company.salesAccounts.length - 6) + " autre(s) ", 1))
                                              : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "items", "label", "rules", "disabled", "item-title"])), [
                                        [_directive_tooltip, 
                                        _ctx.company.solution === 'MANAGEMENT'
                                            ? _ctx.$t('settings.salesAccountingAccountManagement')
                                            : _ctx.$t('settings.salesAccountingAccount')
                                    ]
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.adminMode && !_ctx.hideCategories)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 1,
                                        class: "d-flex pb-2 pr-1",
                                        cols: "5"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_16, [
                                            _createVNode(_component_v_text_field_filled, {
                                              ref: "companyCategoriesElement",
                                              modelValue: _ctx.company.categories,
                                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.company.categories) = $event)),
                                              label: _ctx.$t('settings.categories'),
                                              "hide-details": "auto",
                                              disabled: _ctx.auditReportMode
                                            }, null, 8, ["modelValue", "label", "disabled"]),
                                            (_ctx.$refs.companyCategoriesElement)
                                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                  key: 0,
                                                  activator: "parent"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString((_ctx.$refs.companyCategoriesElement as VTextField)?.label), 1)
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_row, {
                            "no-gutters": "",
                            class: "py-2"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.settingsMode)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    class: "d-flex pr-2",
                                    cols: "2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_17, [
                                        _createVNode(_component_oss_text_field_filled, {
                                          modelValue: _ctx.shareCapital,
                                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.shareCapital) = $event)),
                                          label: _ctx.shareCapitalLabel,
                                          rules: _ctx.requiredRule,
                                          required: "",
                                          disabled: _ctx.auditReportMode
                                        }, null, 8, ["modelValue", "label", "rules", "disabled"]),
                                        _createVNode(_component_v_tooltip, { activator: "parent" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.shareCapitalLabel), 1)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.settingsMode)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 1,
                                    class: "d-flex pr-2",
                                    cols: "2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_18, [
                                        _createVNode(_component_oss_text_field_filled, {
                                          modelValue: _ctx.shareTotal,
                                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.shareTotal) = $event)),
                                          label: _ctx.shareTotalLabel,
                                          disabled: _ctx.auditReportMode
                                        }, null, 8, ["modelValue", "label", "disabled"]),
                                        _createVNode(_component_v_tooltip, { activator: "parent" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.shareTotalLabel), 1)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.settingsMode)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 2,
                                    class: "d-flex pr-2",
                                    cols: "3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_19, [
                                        _createVNode(_component_oss_text_field_filled, {
                                          modelValue: _ctx.company.salaryCount,
                                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.company.salaryCount) = $event)),
                                          label: _ctx.numberOfEmployeesLabel,
                                          rules: _ctx.requiredRule,
                                          required: "",
                                          disabled: _ctx.auditReportMode
                                        }, null, 8, ["modelValue", "label", "rules", "disabled"]),
                                        _createVNode(_component_v_tooltip, { activator: "parent" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.numberOfEmployeesLabel), 1)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_col, {
                                cols: "5",
                                class: "d-flex justify-center"
                              }, {
                                default: _withCtx(() => [
                                  (!_ctx.getDisabled(!_ctx.adminMode))
                                    ? (_openBlock(), _createBlock(_component_v_switch, {
                                        key: 0,
                                        modelValue: _ctx.company.vehicle,
                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.company.vehicle) = $event)),
                                        label: _ctx.$t('settings.vehicle'),
                                        class: "d-flex pr-2 mt-1"
                                      }, null, 8, ["modelValue", "label"]))
                                    : _createCommentVNode("", true),
                                  (!_ctx.getDisabled(!_ctx.adminMode))
                                    ? (_openBlock(), _createBlock(_component_v_switch, {
                                        key: 1,
                                        modelValue: _ctx.company.shop,
                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.company.shop) = $event)),
                                        label: _ctx.$t('settings.withStore'),
                                        class: "d-flex pr-2 mt-1",
                                        "data-cy": "EditCompany-caisse"
                                      }, null, 8, ["modelValue", "label"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_20, [
                                    _createVNode(_component_v_combobox_filled, {
                                      ref: "timeZoneElement",
                                      modelValue: _ctx.company.timeZone,
                                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.company.timeZone) = $event)),
                                      items: _ctx.timeZones,
                                      label: "Fuseau horaire",
                                      dense: "",
                                      disabled: _ctx.auditReportMode
                                    }, null, 8, ["modelValue", "items", "disabled"]),
                                    (_ctx.$refs.timeZoneElement)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          activator: "parent"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((_ctx.$refs.timeZoneElement as VCombobox)?.label), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "2" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createVNode(_component_v_text_field_filled, {
                                      ref: "externalIdElement",
                                      modelValue: _ctx.company.externalId,
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.company.externalId) = $event)),
                                      label: "Identifiant Externe",
                                      dense: "",
                                      class: "pl-2",
                                      disabled: _ctx.auditReportMode
                                    }, null, 8, ["modelValue", "disabled"]),
                                    (_ctx.$refs.externalIdElement)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          activator: "parent"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((_ctx.$refs.externalIdElement as VTextField)?.label), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }),
                              (_ctx.isRoot)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.company.agirisId,
                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.company.agirisId) = $event)),
                                        maxLength: "50",
                                        label: "Identifiant Agiris",
                                        dense: "",
                                        class: "pl-2",
                                        disabled: _ctx.auditReportMode
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.isRoot)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "default_card large mx-0 my-2 pa-2",
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "d-flex justify-start align-center pb-2"
                          }, {
                            default: _withCtx(() => _cache[55] || (_cache[55] = [
                              _createElementVNode("h2", null, "Options du client bobbee (type de client / tarification,...)", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_form, {
                        modelValue: _ctx.isCompanySettingsFormValid,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.isCompanySettingsFormValid) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "py-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "2",
                                        class: "d-flex align-center pl-3 pr-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_switch, {
                                            modelValue: _ctx.company.accountingFirm,
                                            "onUpdate:modelValue": [
                                              _cache[29] || (_cache[29] = ($event: any) => ((_ctx.company.accountingFirm) = $event)),
                                              _cache[30] || (_cache[30] = ($event: any) => (_ctx.setBobbeePriceList(true)))
                                            ],
                                            label: "Société comptable",
                                            class: "mt-0 pt-0",
                                            size: "small",
                                            readonly: _ctx.company.bobbeePriceList?.id
                                          }, null, 8, ["modelValue", "readonly"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "2",
                                        class: "d-flex align-center pl-3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_switch, {
                                            modelValue: _ctx.company.enableAccountingFirms,
                                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.company.enableAccountingFirms) = $event)),
                                            label: "Cabinets multiples",
                                            class: "mt-0 pt-0",
                                            size: "small"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      (_ctx.isRoot)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            cols: "4",
                                            class: "d-flex align-center pl-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_22, [
                                                _createVNode(_component_v_select_filled, {
                                                  ref: "clientUserAccessRightElement",
                                                  modelValue: _ctx.company.clientUserAccessRight,
                                                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.company.clientUserAccessRight) = $event)),
                                                  items: _ctx.clientUserAccessRights,
                                                  "item-value": "id",
                                                  label: "Mode d'accès",
                                                  "item-title": (item) => item.name
                                                }, null, 8, ["modelValue", "items", "item-title"]),
                                                (_ctx.$refs.clientUserAccessRightElement)
                                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                      key: 0,
                                                      activator: "parent"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString((_ctx.$refs.clientUserAccessRightElement as VSelect)
                                                        ?.label), 1)
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex align-center pl-3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field_filled, {
                                            "model-value": _ctx.bobbeePriceListName,
                                            label: "Grille tarifaire",
                                            readonly: ""
                                          }, null, 8, ["model-value"])
                                        ]),
                                        _: 1
                                      }),
                                      (_ctx.bobbeePriceList?.version === 2)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 1,
                                            cols: "3",
                                            class: "d-flex pr-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field_filled, {
                                                hint: "Pour modifier votre offre, veuiller consulter votre comptable",
                                                "hide-details": !_ctx.isAccountingClient,
                                                required: "",
                                                "disable-lookup": "",
                                                readonly: 
                                                _ctx.isAccountingClient || _ctx.accountingFirm ? true : false
                                            ,
                                                label: 'Type d\'offre',
                                                "model-value": _ctx.offerValue
                                              }, null, 8, ["hide-details", "readonly", "model-value"])
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_ctx.bobbeePriceList?.version === 2)
                                        ? (_openBlock(), _createBlock(_component_v_col, { key: 2 }, {
                                            default: _withCtx(() => [
                                              (_ctx.company.accountingFirm)
                                                ? (_openBlock(), _createBlock(_component_oss_dialog, {
                                                    key: 0,
                                                    modelValue: _ctx.offerDialog,
                                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.offerDialog) = $event)),
                                                    height: "100vh",
                                                    width: "70vw"
                                                  }, {
                                                    activator: _withCtx(({ props }) => [
                                                      (_ctx.isOfferWriteRight)
                                                        ? (_openBlock(), _createBlock(_component_v_btn, _normalizeProps(_mergeProps({ key: 0 }, props)), {
                                                            default: _withCtx(() => _cache[56] || (_cache[56] = [
                                                              _createTextVNode(" Modifier ")
                                                            ])),
                                                            _: 2
                                                          }, 1040))
                                                        : (_openBlock(), _createBlock(_component_v_btn, _normalizeProps(_mergeProps({ key: 1 }, props)), {
                                                            default: _withCtx(() => _cache[57] || (_cache[57] = [
                                                              _createTextVNode(" Afficher ")
                                                            ])),
                                                            _: 2
                                                          }, 1040))
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_23, [
                                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, { cols: "12" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_AccountingOffer, { heightMax: "80vh" })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }),
                                                        (_ctx.isOfferWriteRight)
                                                          ? (_openBlock(), _createBlock(_component_v_radio_group, {
                                                              key: 0,
                                                              modelValue: _ctx.newOfferType,
                                                              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.newOfferType) = $event)),
                                                              "hide-details": "",
                                                              class: "pt-0 mt-0",
                                                              color: "primary"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_col, { cols: "4" }),
                                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_radio, {
                                                                          class: "justify-center align-center",
                                                                          value: 1
                                                                        })
                                                                      ]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_radio, {
                                                                          class: "justify-center align-center",
                                                                          value: 2
                                                                        })
                                                                      ]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_radio, {
                                                                          class: "justify-center align-center",
                                                                          value: 3
                                                                        })
                                                                      ]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                                      default: _withCtx(() => [
                                                                        (!_ctx.companyId)
                                                                          ? (_openBlock(), _createBlock(_component_v_tooltip, { key: 0 }, {
                                                                              activator: _withCtx(({ props }) => [
                                                                                _createVNode(_component_v_radio, _mergeProps(props, {
                                                                                  class: "justify-center align-center",
                                                                                  value: 7
                                                                                }), null, 16)
                                                                              ]),
                                                                              default: _withCtx(() => [
                                                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t(
                                                                        "training-text.description-text",
                                                                    )), 1)
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true)
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            }, 8, ["modelValue"]))
                                                          : (_openBlock(), _createElementBlock("p", _hoisted_24, " Pour modifier votre offre, veuiller consulter votre comptable "))
                                                      ])
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"]))
                                                : (_openBlock(), _createBlock(_component_oss_dialog, {
                                                    key: 1,
                                                    modelValue: _ctx.offerDialog,
                                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.offerDialog) = $event)),
                                                    height: "100vh",
                                                    width: "70vw"
                                                  }, {
                                                    activator: _withCtx(({ props }) => [
                                                      (_ctx.isOfferWriteRight)
                                                        ? (_openBlock(), _createBlock(_component_v_btn, _normalizeProps(_mergeProps({ key: 0 }, props)), {
                                                            default: _withCtx(() => _cache[58] || (_cache[58] = [
                                                              _createTextVNode(" Modifier ")
                                                            ])),
                                                            _: 2
                                                          }, 1040))
                                                        : (_openBlock(), _createBlock(_component_v_btn, _normalizeProps(_mergeProps({ key: 1 }, props)), {
                                                            default: _withCtx(() => _cache[59] || (_cache[59] = [
                                                              _createTextVNode(" Afficher ")
                                                            ])),
                                                            _: 2
                                                          }, 1040))
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_25, [
                                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, { cols: "12" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_BusinessOffer, { maxHeight: "80vh" })
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }),
                                                        (_ctx.isOfferWriteRight)
                                                          ? (_openBlock(), _createBlock(_component_v_radio_group, {
                                                              key: 0,
                                                              modelValue: _ctx.newOfferType,
                                                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.newOfferType) = $event)),
                                                              "hide-details": "",
                                                              class: "pt-0 mt-0",
                                                              color: "primary"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_col, { cols: "4" }),
                                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                                      default: _withCtx(() => [
                                                                        (_ctx.isFreemiumAccepted)
                                                                          ? (_openBlock(), _createBlock(_component_v_radio, {
                                                                              key: 0,
                                                                              class: "justify-center align-center",
                                                                              value: 4
                                                                            }))
                                                                          : _createCommentVNode("", true)
                                                                      ]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_radio, {
                                                                          class: "justify-center align-center",
                                                                          value: 8
                                                                        })
                                                                      ]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_radio, {
                                                                          class: "justify-center align-center",
                                                                          value: 5
                                                                        })
                                                                      ]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_radio, {
                                                                          class: "justify-center align-center",
                                                                          value: 6
                                                                        })
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 1
                                                                })
                                                              ]),
                                                              _: 1
                                                            }, 8, ["modelValue"]))
                                                          : (_openBlock(), _createElementBlock("p", _hoisted_26, " Pour modifier votre offre, veuiller consulter votre comptable "))
                                                      ])
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"]))
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.clientInvoiceMode && _ctx.settingsMode)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "default_card large mx-0 my-2 pa-2",
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "d-flex justify-start align-center pb-2"
                          }, {
                            default: _withCtx(() => _cache[60] || (_cache[60] = [
                              _createElementVNode("h2", null, "Régimes d'imposition", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_form, {
                        ref: "taxDetailsForm",
                        modelValue: _ctx.isTaxDetailsFormValid,
                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.isTaxDetailsFormValid) = $event)),
                        disabled: _ctx.auditReportMode
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              (_ctx.settingsMode)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    class: "d-flex pr-2",
                                    cols: "2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_27, [
                                        _createVNode(_component_v_select_filled, {
                                          ref: "accountingTypeElement",
                                          modelValue: _ctx.profile.accountingType,
                                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.profile.accountingType) = $event)),
                                          items: _ctx.accountingTypes,
                                          "item-value": "id",
                                          rules: _ctx.requiredRule,
                                          required: "",
                                          label: _ctx.$t('settings.accountingType') + ' *',
                                          "item-title": (item) => item.name,
                                          "data-cy": "EditCompany-accountingType"
                                        }, null, 8, ["modelValue", "items", "rules", "label", "item-title"]),
                                        (_ctx.$refs.accountingTypeElement)
                                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                              key: 0,
                                              activator: "parent"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString((_ctx.$refs.accountingTypeElement as VSelect)?.label), 1)
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.vatSystemHide)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 1,
                                    class: "d-flex pr-2",
                                    cols: "2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_28, [
                                        _createVNode(_component_v_select_filled, {
                                          ref: "vatSystemElement",
                                          modelValue: _ctx.company.vatSystem,
                                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.company.vatSystem) = $event)),
                                          items: _ctx.vatSystems,
                                          "item-value": "id",
                                          rules: _ctx.requiredRule,
                                          required: "",
                                          label: _ctx.$t('settings.vatSystem') + ' *',
                                          "item-title": (item) => item.name,
                                          "data-cy": "EditCompany-VATSystem"
                                        }, null, 8, ["modelValue", "items", "rules", "label", "item-title"]),
                                        (_ctx.$refs.vatSystemElement)
                                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                              key: 0,
                                              activator: "parent"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString((_ctx.$refs.vatSystemElement as VSelect)?.label), 1)
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.vatSystemHide)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 2,
                                    class: "d-flex pr-2",
                                    cols: "2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_29, [
                                        _createVNode(_component_v_select_filled, {
                                          ref: "vatDeclarationDayElement",
                                          modelValue: _ctx.company.vatDeclarationDay,
                                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.company.vatDeclarationDay) = $event)),
                                          items: _ctx.vatDeclarationDays,
                                          label: "Jour déclaration TVA",
                                          disabled: 
                                            _ctx.company.vatSystem === 'NotSubjectTo' || _ctx.auditReportMode
                                        
                                        }, null, 8, ["modelValue", "items", "disabled"]),
                                        (_ctx.$refs.vatDeclarationDayElement)
                                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                              key: 0,
                                              activator: "parent"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString((_ctx.$refs.vatDeclarationDayElement as VSelect)?.label), 1)
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.settingsMode)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 3,
                                    class: "d-flex pr-2",
                                    cols: "2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_30, [
                                        _createVNode(_component_v_select_filled, {
                                          ref: "incomeCategoryElement",
                                          modelValue: _ctx.company.incomeCategory,
                                          "onUpdate:modelValue": [
                                            _cache[41] || (_cache[41] = ($event: any) => ((_ctx.company.incomeCategory) = $event)),
                                            _ctx.changeTaxSystemTypes
                                          ],
                                          items: _ctx.incomeCategories,
                                          "item-value": "id",
                                          rules: _ctx.requiredRule,
                                          required: "",
                                          label: _ctx.$t('settings.incomeCategory') + ' *',
                                          "item-title": (item) => item.name,
                                          "data-cy": "EditCompany-taxSystem"
                                        }, null, 8, ["modelValue", "items", "onUpdate:modelValue", "rules", "label", "item-title"]),
                                        (_ctx.$refs.taxSystemElement)
                                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                              key: 0,
                                              activator: "parent"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString((_ctx.$refs.incomeCategoryElement as VSelect)?.label), 1)
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.settingsMode)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 4,
                                    class: "d-flex pr-2",
                                    cols: "2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_31, [
                                        _createVNode(_component_v_select_filled, {
                                          ref: "taxRegimeElement",
                                          modelValue: _ctx.company.taxRegime,
                                          "onUpdate:modelValue": [
                                            _cache[42] || (_cache[42] = ($event: any) => ((_ctx.company.taxRegime) = $event)),
                                            _ctx.changeTaxSystemTypes
                                          ],
                                          items: _ctx.taxRegimes,
                                          "item-value": "id",
                                          rules: _ctx.requiredRule,
                                          required: "",
                                          label: _ctx.$t('settings.taxRegime') + ' *',
                                          "item-title": (item) => item.name,
                                          "data-cy": "EditCompany-taxRegimeElement"
                                        }, null, 8, ["modelValue", "items", "onUpdate:modelValue", "rules", "label", "item-title"]),
                                        _createVNode(_component_v_tooltip, { activator: "parent" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((_ctx.$refs.taxRegimeElement as VSelect)?.label), 1)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.settingsMode)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 5,
                                    class: "d-flex pr-1",
                                    cols: "2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_32, [
                                        _createVNode(_component_v_select_filled, {
                                          ref: "taxSystemTypeElement",
                                          modelValue: _ctx.company.taxSystemType,
                                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.company.taxSystemType) = $event)),
                                          items: _ctx.taxSystemTypes,
                                          "item-value": "id",
                                          rules: _ctx.requiredRule,
                                          required: "",
                                          label: _ctx.$t('settings.taxSystemType') + ' *',
                                          "item-title": (item) => item.name,
                                          "data-cy": "EditCompany-taxSystemType"
                                        }, null, 8, ["modelValue", "items", "rules", "label", "item-title"]),
                                        (_ctx.$refs.taxSystemTypeElement)
                                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                              key: 0,
                                              activator: "parent"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString((_ctx.$refs.taxSystemTypeElement as VSelect)?.label), 1)
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, {
                            "no-gutters": "",
                            class: "pt-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "3",
                                class: "pr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createVNode(_component_v_autocomplete_filled, {
                                      ref: "corporateTaxDepartmentElement",
                                      modelValue: _ctx.company.corporateTaxDepartment,
                                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.company.corporateTaxDepartment) = $event)),
                                      items: _ctx.sieList,
                                      "item-title": _ctx.formatItemTitle,
                                      "item-value": "id",
                                      label: "Service des impôts des entreprises"
                                    }, null, 8, ["modelValue", "items", "item-title"]),
                                    (_ctx.$refs.corporateTaxDepartmentElement)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          activator: "parent"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((_ctx.$refs.corporateTaxDepartmentElement as VAutocomplete)
                                                ?.label), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "2",
                                class: "pr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_34, [
                                    _createVNode(_component_oss_date_picker_filled, {
                                      ref: "startBusinessDateElement",
                                      modelValue: _ctx.company.startBusinessDate,
                                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.company.startBusinessDate) = $event)),
                                      label: "Date de début d'activité",
                                      style: {"flex":"1"},
                                      textFieldReadOnly: false,
                                      required: false,
                                      notRequired: true,
                                      disabled: _ctx.auditReportMode
                                    }, null, 8, ["modelValue", "disabled"]),
                                    (_ctx.$refs.startBusinessDateElement)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          activator: "parent"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((_ctx.$refs.startBusinessDateElement as any)?.label), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "2",
                                class: "pr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_35, [
                                    _createVNode(_component_oss_date_picker_filled, {
                                      ref: "firstAccountingPeriodEndElement",
                                      modelValue: _ctx.company.firstAccountingPeriodEnd,
                                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.company.firstAccountingPeriodEnd) = $event)),
                                      label: "Date de fin du 1er exercice",
                                      style: {"flex":"1"},
                                      textFieldReadOnly: false,
                                      required: false,
                                      notRequired: true,
                                      disabled: _ctx.auditReportMode
                                    }, null, 8, ["modelValue", "disabled"]),
                                    (_ctx.$refs.firstAccountingPeriodEndElement)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          activator: "parent"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((_ctx.$refs.firstAccountingPeriodEndElement as any)?.label), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                class: "d-flex pr-1",
                                cols: "5"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_36, [
                                    _createVNode(_component_v_select_filled, {
                                      ref: "vatOptionElement",
                                      disabled: 
                                            _ctx.company.vatSystem === 'NotSubjectTo' || _ctx.auditReportMode
                                        ,
                                      modelValue: _ctx.company.vatOption,
                                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.company.vatOption) = $event)),
                                      items: _ctx.vatOptions,
                                      "item-value": "id",
                                      rules: _ctx.requiredRuleIfVATSubjectTo,
                                      label: _ctx.$t('settings.vatOption') + ' *',
                                      "item-title": (item) => item.name,
                                      style: {"height":"20px"}
                                    }, null, 8, ["disabled", "modelValue", "items", "rules", "label", "item-title"]),
                                    (_ctx.$refs.vatOptionElement)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          activator: "parent"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((_ctx.$refs.vatOptionElement as VSelect)?.label), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.clientInvoiceMode && _ctx.settingsMode && _ctx.isAuthorizedAccountableAccountTable)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 2,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "default_card large mx-0 my-2 pa-2",
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "d-flex justify-start align-center pb-2"
                          }, {
                            default: _withCtx(() => _cache[61] || (_cache[61] = [
                              _createElementVNode("h2", null, "Plan comptable", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          (_ctx.settingsMode)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                class: "d-flex pr-2",
                                cols: "3"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_37, [
                                    _createVNode(_component_v_select_filled, {
                                      "return-object": "",
                                      ref: "accountableAccountTableElement",
                                      modelValue: _ctx.selectedAccountableAccountTable,
                                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.selectedAccountableAccountTable) = $event)),
                                      items: _ctx.accountableAccountTables,
                                      rules: _ctx.accountableAccountTablesRule,
                                      required: "",
                                      disabled: 
                                        _ctx.getDisabledAccountableAccountTable() || _ctx.auditReportMode
                                    ,
                                      readonly: _ctx.getDisabledAccountableAccountTable(),
                                      "item-title": "name",
                                      label: 'Plan comptable *',
                                      "data-cy": "EditCompany-planComptable"
                                    }, null, 8, ["modelValue", "items", "rules", "disabled", "readonly", "item-title"]),
                                    (_ctx.$refs.accountableAccountTableElement)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          activator: "parent"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((_ctx.$refs.accountableAccountTableElement as VSelect)?.label), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isRoot && _ctx.bobbeePriceList?.version === 2)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 3,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "default_card large mx-0 my-2 pa-2",
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "d-flex justify-start align-center pb-2"
                          }, {
                            default: _withCtx(() => _cache[62] || (_cache[62] = [
                              _createElementVNode("h2", null, "Type d'offre", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "d-flex align-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "3",
                            class: "d-flex pr-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_38, [
                                _createVNode(_component_v_text_field_filled, {
                                  ref: "offerElement",
                                  hint: "Pour modifier votre offre, veuiller consulter votre comptable",
                                  "hide-details": !_ctx.isAccountingClient,
                                  required: "",
                                  "disable-lookup": "",
                                  readonly: _ctx.isAccountingClient || _ctx.accountingFirm ? true : false,
                                  label: 'Type d\'offre',
                                  "model-value": _ctx.offerValue,
                                  disabled: _ctx.auditReportMode
                                }, null, 8, ["hide-details", "readonly", "model-value", "disabled"]),
                                (_ctx.$refs.offerElement)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      activator: "parent"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString((_ctx.$refs.offerElement as VTextField)?.label), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              (_ctx.isAccountingClient || _ctx.accountingFirm)
                                ? (_openBlock(), _createBlock(_component_oss_dialog, {
                                    key: 0,
                                    modelValue: _ctx.offerDialog,
                                    "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.offerDialog) = $event)),
                                    height: "100vh",
                                    width: "70vw"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      (_ctx.isOfferWriteRight)
                                        ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({
                                            key: 0,
                                            size: "small"
                                          }, props, { disabled: _ctx.auditReportMode }), {
                                            default: _withCtx(() => _cache[63] || (_cache[63] = [
                                              _createTextVNode(" Modifier ")
                                            ])),
                                            _: 2
                                          }, 1040, ["disabled"]))
                                        : (_openBlock(), _createBlock(_component_v_btn, _mergeProps({
                                            key: 1,
                                            size: "small"
                                          }, props, { disabled: _ctx.auditReportMode }), {
                                            default: _withCtx(() => _cache[64] || (_cache[64] = [
                                              _createTextVNode(" Afficher ")
                                            ])),
                                            _: 2
                                          }, 1040, ["disabled"]))
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_39, [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "12" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_AccountingOffer, { heightMax: "80vh" })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_ctx.isOfferWriteRight)
                                          ? (_openBlock(), _createBlock(_component_v_radio_group, {
                                              key: 0,
                                              modelValue: _ctx.newOfferType,
                                              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.newOfferType) = $event)),
                                              "hide-details": "",
                                              class: "pt-0 mt-0",
                                              color: "primary"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { cols: "4" }),
                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_radio, {
                                                          class: "justify-center align-center",
                                                          value: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_radio, {
                                                          class: "justify-center align-center",
                                                          value: 2
                                                        })
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_radio, {
                                                          class: "justify-center align-center",
                                                          value: 3
                                                        })
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                      default: _withCtx(() => [
                                                        (!_ctx.companyId)
                                                          ? (_openBlock(), _createBlock(_component_v_tooltip, { key: 0 }, {
                                                              activator: _withCtx(({ props }) => [
                                                                _createVNode(_component_v_radio, _mergeProps({
                                                                  class: "justify-center align-center",
                                                                  value: 7
                                                                }, props), null, 16)
                                                              ]),
                                                              default: _withCtx(() => [
                                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("training-text.description-text")), 1)
                                                              ]),
                                                              _: 1
                                                            }))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"]))
                                          : (_openBlock(), _createElementBlock("p", _hoisted_40, " Pour modifier votre offre, veuiller consulter votre comptable "))
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                : (_openBlock(), _createBlock(_component_oss_dialog, {
                                    key: 1,
                                    modelValue: _ctx.offerDialog,
                                    "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.offerDialog) = $event)),
                                    height: "100vh",
                                    width: "70vw"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      (_ctx.isOfferWriteRight)
                                        ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 0 }, props, { disabled: _ctx.auditReportMode }), {
                                            default: _withCtx(() => _cache[65] || (_cache[65] = [
                                              _createTextVNode(" Modifier ")
                                            ])),
                                            _: 2
                                          }, 1040, ["disabled"]))
                                        : (_openBlock(), _createBlock(_component_v_btn, _normalizeProps(_mergeProps({ key: 1 }, props)), {
                                            default: _withCtx(() => _cache[66] || (_cache[66] = [
                                              _createTextVNode(" Afficher ")
                                            ])),
                                            _: 2
                                          }, 1040))
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_41, [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "12" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_BusinessOffer, { maxHeight: "80vh" })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_ctx.isOfferWriteRight)
                                          ? (_openBlock(), _createBlock(_component_v_radio_group, {
                                              key: 0,
                                              modelValue: _ctx.newOfferType,
                                              "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.newOfferType) = $event)),
                                              "hide-details": "",
                                              class: "pt-0 mt-0",
                                              color: "primary"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { cols: "4" }),
                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                      default: _withCtx(() => [
                                                        (_ctx.isFreemiumAccepted)
                                                          ? (_openBlock(), _createBlock(_component_v_radio, {
                                                              key: 0,
                                                              class: "justify-center align-center",
                                                              value: 4
                                                            }))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_radio, {
                                                          class: "justify-center align-center",
                                                          value: 8
                                                        })
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_radio, {
                                                          class: "justify-center align-center",
                                                          value: 5
                                                        })
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_radio, {
                                                          class: "justify-center align-center",
                                                          value: 6
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"]))
                                          : (_openBlock(), _createElementBlock("p", _hoisted_42, " Pour modifier votre offre, veuiller consulter votre comptable "))
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.clientInvoiceMode)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 4,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ResourceAllocationEdition, {
                    ref: "resourceAllocation",
                    companyId: _ctx.companyId
                  }, null, 8, ["companyId"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: "12",
            style: _normalizeStyle({ display: _ctx.isAccountingUser && !_ctx.clientInvoiceMode ? 'block' : 'none' })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AccountingFirmClientEdition, {
                ref: "accountingFirmClient",
                companyId: _ctx.companyId,
                auditReportMode: _ctx.auditReportMode
              }, null, 8, ["companyId", "auditReportMode"])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}